import React from "react";
import { Document, Page, Text, Image } from "@react-pdf/renderer";
import PropTypes from "prop-types";
import logotipo from "../../assets/img/logotipo.png";
import useContractDocumentStyles from "styles/useContractDocumentStyles";

const styles = useContractDocumentStyles;
const DocumentContract = ({
  values,
  datoscliente,
  datoscedentes,
  datoslote,
  datoscontrato
}) => (
  <Document>
    <Page className="page" style={styles.page}>
      <Image
        style={[styles.imageSection, styles.image]}
        src={logotipo}
        align="center"
      />
      <Text style={styles.title}>{values.introduccion.titulo}</Text>
      <Text style={[styles.body]}>
        {values.introduccion.descripcion[0]}
        <Text style={[styles.body, styles.boldText]}>
          {datoscedentes.nombrecedente}
        </Text>
        {values.introduccion.descripcion[1]}
        <Text style={[styles.body, styles.boldText]}>
          {datoscedentes.domiciliocedente}
        </Text>
        {values.introduccion.descripcion[2]}
        <Text style={[styles.body, styles.boldText]}>
          {datoscedentes.credencialcedente}
        </Text>
        {values.introduccion.descripcion[3]}
        <Text style={[styles.body, styles.redText, styles.boldText]}>
          {values.introduccion.descripcion[4] + datoscliente.nombrecliente}
        </Text>
        <Text style={[styles.body, styles.redText]}>
          {values.introduccion.descripcion[5] +
            datoscliente.domiciliocliente +
            values.introduccion.descripcion[6] +
            datoscliente.numerotelefonico}
        </Text>
        {values.introduccion.descripcion[7]}
        <Text style={[styles.body, styles.redText, styles.boldText]}>
          {datoscliente.credencialcliente}
        </Text>
        {values.introduccion.descripcion[8]}
      </Text>

      <Text style={styles.lineBreak}>{"\n"}</Text>
      <Text style={[styles.title, styles.boldText]}>
        {values.declaraciones.titulo}
      </Text>
      <Text style={styles.lineBreak}>{"\n"}</Text>
      <Text style={[styles.body]}>{values.declaraciones.descripcion[0]}</Text>
      <Text style={styles.lineBreak}>{"\n"}</Text>
      <Text style={[styles.body]}>{values.declaraciones.descripcion[1]}</Text>
      <Text style={styles.lineBreak}>{"\n"}</Text>
      <Text style={[styles.body]}>
        {"PRIMERA. -DECLARA EL C. ALFREDO CORONA RUIZ, SER PROPIETARIO DEL " +
          "DESARROLLO RUSTICO RANCHO ALEGRE CUAL CONSTA EN EL CERTIFICADO NO. 000001034798," +
          "DE FECHA DEL 22 (VEINTIDÓS), DE MAYO DE 2017 (DOS MIL DIECISIETE)" +
          "DEBIDAMENTE INSCRITA EN EL REGISTRO AGRARIO," +
          "DE LA PARCELA NO. 26 Z-1 P1/9 PROPIEDAD QUE HA FRACCIONADO EN LOTES RÚSTICOS," +
          "SIENDO SU INTENCIÓN CEDERLOS," +
          "MANIFESTANDO TENER PLENA CAPACIDAD JURÍDICA PARA HACERLO UBICADA EN EL EJIDO SANTA MONICA," +
          "MUNICIPIO DE EPAZOYUCAN, ESTADO DE HIDALGO"}
      </Text>
      <Text style={styles.lineBreak}>{"\n"}</Text>
      <Text style={[styles.body]}>
        <Text style={styles.boldText}>SEGUNDA. -</Text> AMBOS CONTRATANTES
        ACUERDAN QUE SE
        <Text style={[styles.body, styles.redText, styles.boldText]}>
          {datoscontrato.tipocontrato == "contado"
            ? " LIQUIDARA DE CONTADO "
            : " SE PAGARA A UN PLAZO "}
        </Text>
        EN LA FECHA EN QUE SE FIRME EL PRESENTE INSTRUMENTO Y UNA VEZ QUE NO
        EXISTA ADEUDO ALGUNO POR PARTE DEL CESIONARIO, CONTRATO DEFINITIVO A
        TÍTULO ONEROSO,
        {" RESPECTO DEL LOTE SEÑALADO CON EL NUMERO "}
        <Text style={[styles.body, styles.redText]}>
          {datoslote.NUMEROSLOTES}
          <Text style={[styles.boldText]}>{" DE LA MANZANA "}</Text>
          {datoslote.NUMEROSMANZANA}
        </Text>
        {" UBICADO EN EL LUGAR DENOMINADO "}
        <Text style={[styles.body, styles.boldText]}>
          DESARROLLO RUSTICO RANCHO ALEGRE
        </Text>
        {" PERTENECIENTE AL MUNICIPIO EPAZOYUCAN, HIDALGO; "}
        SIENDO ESTO ANTE LA PRESENCIA DE TESTIGOS, ASÍ COMO DAR CUMPLIMIENTO A
        LO ESTIPULADO.
      </Text>
      <Text style={styles.lineBreak}>{"\n"}</Text>
      <Text style={[styles.body]}>
        <Text style={styles.boldText}>TERCERA. -</Text>TANTO EL CEDENTE COMO EL
        CESIONARIO, SE OBLIGAN A CEDER Y ADQUIRIR RESPECTIVAMENTE PARA SI O PARA
        LA PERSONA FÍSICA O MORAL QUE PARA EL EFECTO QUE DESIGNE, EL LOTE
        RÚSTICO, CITADO EN EL PÁRRAFO QUE ANTECEDE; MISMO QUE CUENTA CON LAS
        SIGUIENTES MEDIDAS Y COLINDANCIAS:
      </Text>
      <Text style={styles.lineBreak}>{"\n"}</Text>
      {Object.values(datoslote.lotes).map(lote => (
        <>
          <Text style={styles.lineBreak}>{"\n"}</Text>
          <Text style={[styles.title, styles.boldText, styles.redText]}>
            LOTE {lote.NUMERO} MANZANA {lote.CODIGO}
          </Text>
          <Text style={styles.lineBreak}>{"\n"}</Text>
          <Text style={[styles.bodyn, styles.redText]}>
            {lote.COLINDANCIA_UNO}
          </Text>
          <Text style={styles.lineBreak}>{"\n"}</Text>
          <Text style={[styles.bodyn, styles.redText]}>
            {lote.COLINDANCIA_DOS}
          </Text>
          <Text style={styles.lineBreak}>{"\n"}</Text>
          <Text style={[styles.bodyn, styles.redText]}>
            {lote.COLINDANCIA_TRES}
          </Text>
          <Text style={styles.lineBreak}>{"\n"}</Text>
          <Text style={[styles.bodyn, styles.redText]}>
            {lote.COLINDANCIA_CUATRO}
          </Text>
          <Text style={styles.lineBreak}>{"\n"}</Text>
          <Text style={[styles.bodyn, styles.redText]}>
            TENIENDO UNA SUPERFICIE TOTAL DE {lote.SUPERFICIE} METROS CUADRADOS.
          </Text>
        </>
      ))}
      <Text style={styles.lineBreak}>{"\n"}</Text>
      <Text style={[styles.body]}>
        <Text style={styles.boldText}>CUARTA.- </Text>AMBOS PRE CONTRATANTES
        ACUERDAN QUE EL COSTO TOTAL DE LA OPERACIÓN SERÁ DE
        <Text style={[styles.body, styles.boldText]}>
          {" "}
          ${datoslote.TOTALCOSTO} ({datoslote.COSTOLETRA} 00/100 M/.N.),
        </Text>{" "}
        MISMA SERÁ CUBIERTA POR EL COMPRADOR A ENTERA SATISFACCIÓN DEL PRE
        VENDEDOR, DE LA SIGUIENTE MANERA:
        {datoscontrato.tipocontrato == "contado" ? (
          <>
            LIQUIDADO DE CONTADO BAJO UN UNICO MONTO DE{" "}
            <Text style={[styles.body, styles.boldText]}>
              ${datoscontrato.pagos} ({datoscontrato.pagosletras} 00/100 M/N.)
            </Text>
          </>
        ) : (
          <>
            ENGANCHE DE{" "}
            <Text style={[styles.body, styles.boldText]}>
              ${datoscontrato.enganche} ({datoscontrato.engancheletras} 00/100
              M/N){" "}
            </Text>{" "}
            A LA FIRMA DEL PRESENTE PRECONTRATO Y UN SALDO DE
            <Text style={[styles.body, styles.boldText]}>
              {" "}
              ${datoscontrato.restante}({datoscontrato.restanteletras} 00/100
              M/N)
            </Text>
            , QUE SERÁ LIQUIDADO EN{" "}
            <Text style={[styles.body, styles.boldText]}>
              {datoscontrato.mensualidades}
            </Text>{" "}
            MENSUALIDADES LAS SERAN DE{" "}
            <Text style={[styles.body, styles.boldText]}>
              ${datoscontrato.pagos} ({datoscontrato.pagosletras} 00/100 M/N.)
            </Text>
          </>
        )}
      </Text>
      <Text style={styles.lineBreak}>{"\n"}</Text>
      <Text style={[styles.body]}>
        <Text style={styles.boldText}>QUINTA. -</Text> LOS CONTRATANTES
        MANIFIESTAN QUE PARA EL CASO DE SER MAYOR O MENOR LA SUPERFICIE QUE
        RESULTE A LA ENTREGA DEL LOTE SE BONIFICARÁ O SE CARGARÁ LA DIFERENCIA
        SEGÚN SEA EL CASO.
      </Text>
      <Text style={styles.lineBreak}>{"\n"}</Text>
      <Text style={styles.lineBreak}>{"\n"}</Text>
      <Text style={[styles.body]}>
        <Text style={styles.boldText}>SEXTA. - </Text> AMBOS CONTRATANTES
        ACUERDAN QUE AL MOMENTO DE LA FIRMA DEL PRESENTE CONTRATO A TÍTULO
        ONEROSO RESPECTO DE LOTE DESCRITO Y DESLINDADO EN LA CLÁUSULA TERCERA
        DEL PRESENTE CONTRATO, EL CEDENTE CON LA PERSONALIDAD JURÍDICA QUE
        OSTENTA, SE OBLIGA A ENTREGARLO DESOCUPADO. EL CESIONARIO, POR SU PARTE
        SE COMPROMETE A RECIBIRLO EN EL ESTADO EN EL QUE SE ENCUENTRA,
        MANIFESTANDO CONOCERLO.
      </Text>
      <Text style={styles.lineBreak}>{"\n"}</Text>
      <Text style={[styles.body]}>
        <Text style={styles.boldText}>SEPTIMA. -</Text> EL CESIONARIO ACEPTA
        TENER EL CONOCIMIENTO QUE, PARA ADQUIRIR LOS SERVICIOS DE AGUA, LUZ, O
        DRENAJE Y DEMÁS NECESARIOS EN EL LOTE, MOTIVO DEL PRESENTE CONTRATO,
        TENDRÁ QUE COOPERAR JUNTO CON LAS AUTORIDADES CORRESPONDIENTES PARA
        INTRODUCIRLOS, ASÍ COMO TAMBIÉN SE SUJETARÁ EN LOS REGLAMENTOS
        ESTABLECIDOS POR LAS AUTORIDADES CORRESPONDIENTES.
      </Text>
      <Text style={styles.lineBreak}>{"\n"}</Text>
      <Text style={[styles.body]}>
        <Text style={styles.boldText}>OCTAVA. -</Text> LOS CONTRATANTES ACUERDAN
        EN QUE EL CESIONARIO CUBRIRÁ LOS IMPUESTOS Y GASTOS QUE SE ORIGINEN CON
        MOTIVO DEL TRÁMITE DE USUFRUCTO DEL LOTE RUSTICO DESCRITO Y DESLINDADO
        EN LA CLÁUSULA TERCERA DEL PRESENTE CONTRATO.
      </Text>
      <Text style={styles.lineBreak}>{"\n"}</Text>
      <Text style={[styles.body]}>
        <Text style={styles.boldText}> NOVENA. -</Text> PARA INTERPRETACIÓN Y
        CUMPLIMIENTO DE ESTE CONTRATO LAS PARTES MANIFIESTAN, SOMETERSE A LA
        JURISDICCIÓN DE LOS TRIBUNALES DE PACHUCA DE SOTO HIDALGO, RENUNCIANDO
        EXPRESAMENTE AL FUERO QUE LES PUDIERA CORRESPONDER EN RAZÓN DE SU
        DOMICILIO PRESENTE O FUTURO.
      </Text>
      <Text style={styles.lineBreak}>{"\n"}</Text>
      <Text style={[styles.body]}>
        <Text style={styles.boldText}>DECIMA. -</Text> LAS PARTES CONTRATANTES
        SEÑALAN COMO DOMICILIO PARA RECIBIR NOTIFICACIONES, EMPLAZAMIENTOS O EN
        CUALQUIER OTRO EFECTO LEGAL EL ANTES MENCIONADO EN ESTE CONTRATO.
      </Text>
      <Text style={styles.lineBreak}>{"\n"}</Text>
      <Text style={[styles.body]}>
        <Text style={styles.boldText}>DÉCIMA SEGUNDA. -</Text> EL CEDENTE DA LA
        AUTORIZACIÓN AL CESIONARIO, PARA REALIZAR CUALQUIER TIPO DE OBRA DE
        EDIFICACIÓN QUE ESTE DESEE DENTRO DEL PREDIO CONTRATADO BAJO LAS
        SIGUIENTES CONDICIONES, TODO TIPO DE OBRA QUE REALICE DENTRO DEL TERRENO
        CONTRATADO QUEDARÁ BAJO RESERVA DE DOMINIO A FAVOR DEL CEDENTE, HASTA LA
        LIQUIDACIÓN TOTAL DEL PREDIO SIN CONDICIONANTE ALGUNA, TODO TRAMITE QUE
        SE REQUIERA SERA RESPONSABILIDAD DE CESIONARIO DESLINDANDO DE CUALQUIER
        RESPONSABILIDAD EL CEDENTE, SIN EFECTO DE VENTA O PRENDA A TERCEROS,
        TRASPASO Y CUALQUIER COSA QUE SE REAPAREZCA SOBRE EL TERRENO EN
        CUESTIÓN.
      </Text>
      <Text style={styles.lineBreak}>{"\n"}</Text>
      <Text style={[styles.body]}>
        <Text style={styles.boldText}>DECIMA TERCERA. -</Text>
        LOS CONTRATANTES ACUERDAN COMO PENALIDAD PARA QUIEN SOLICITARA LA
        RESCISIÓN DEL PRESENTE CONTRATO EL 100% DEL MONTO TOTAL DEL LOTE, TANTO
        QUE NO SE REGRESARÁ NINGUNA CANTIDAD QUE HAYAN ABONADO.
      </Text>
    </Page>
  </Document>
);

DocumentContract.propTypes = {
  values: PropTypes.shape({
    introduccion: PropTypes.shape({
      titulo: PropTypes.string.isRequired,
      descripcion: PropTypes.array
    }).isRequired,
    declaraciones: PropTypes.shape({
      titulo: PropTypes.string.isRequired,
      descripcion: PropTypes.array
    }).isRequired,
    clausulas: PropTypes.arrayOf(
      PropTypes.shape({
        titulo: PropTypes.string.isRequired,
        descripcion: PropTypes.string.isRequired
      })
    ).isRequired
  }).isRequired,
  datoscliente: PropTypes.shape({
    nombrecliente: PropTypes.string,
    domiciliocliente: PropTypes.string,
    numerotelefonico: PropTypes.string,
    credencialcliente: PropTypes.string
  }),
  datoscedentes: PropTypes.shape({
    nombrecedente: PropTypes.string,
    domiciliocedente: PropTypes.string,
    credencialcedente: PropTypes.string
  }),
  datoslote: PropTypes.shape({
    lotes: PropTypes.arrayOf(
      PropTypes.shape({
        CODIGO: PropTypes.string,
        COSTO: PropTypes.number,
        NUMERO: PropTypes.number,
        SUPERFICIE: PropTypes.number,
        COLINDANCIA_UNO: PropTypes.string,
        COLINDANCIA_DOS: PropTypes.string,
        COLINDANCIA_TRES: PropTypes.string,
        COLINDANCIA_CUATRO: PropTypes.string
      })
    ),
    COSTOLETRA: PropTypes.string,
    TOTALCOSTO: PropTypes.number,
    totalSuperficie: PropTypes.number,
    NUMEROSLOTES: PropTypes.any,
    NUMEROSMANZANA: PropTypes.string
  }),
  datoscontrato: PropTypes.shape({
    tipocontrato: PropTypes.string,
    testigo1: PropTypes.string,
    testigo2: PropTypes.string,
    tipopago: PropTypes.string,
    mensualidades: PropTypes.number,
    intereses: PropTypes.number,
    fechapago: PropTypes.string,
    pagos: PropTypes.string,
    pagosletras: PropTypes.number,
    enganche: PropTypes.number,
    engancheletras: PropTypes.string,
    restante: PropTypes.number,
    restanteletras: PropTypes.string,
    costoletras: PropTypes.string
  })
};
export default DocumentContract;
